/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * AI API Service
 * API for AI-powered doubt resolution and conversation features.
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AiFeedbackRequest,
  AiFeedbackresponse,
  CreateConversationResponse,
  DoubtSolverRequest,
  DoubtSolverResponse,
  FilterDoubt,
  GetAiConversationsConversationIdGetConversationDetailsParams,
  GetConversationResponse,
  GetDc1MetaSubjectsGradeMappingParams,
  GetDoubtBuddyResponse,
  GetDoubtSolverAnswer,
  GetFollowUpResponse,
  GetMappedSubjectsResponse,
  GetMessageRequestModel,
  GetMessageResponse,
  MyQuestionResponse,
  PostAiConversationsConversationIdContinueParams,
  PostAiConversationsConversationIdContinueSyncParams,
  PostAiConversationsConversationIdUpdateScoreParams,
  PostAiGetFollowUpQuestionsBody,
  PostAiV2CreateConversationBody,
  PostDc1QuestionsImageOCRBody,
  PostImage,
  ProfanityRequest,
  ProfanityResponse,
  SaveViewTypeCountRequest,
  SetAnswerByDoubtsolver,
  SetDoubtBodyResponse,
  SetDoubtBuddyRequest,
  SetRagRequestBody,
  SetRagResponseBody,
  SetViewTypeResponse,
  SetViewtypeRequest,
} from ".././model";

import { customInstance } from "../../../api-client";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Creates a conversation for a doubt, either with an image or just text. The API has two request bodies for this purpose.
 * @summary Create a new conversation
 */
export const postAiV2CreateConversation = (
  postAiV2CreateConversationBody: PostAiV2CreateConversationBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<CreateConversationResponse>(
    {
      url: `/ai/v2/createConversation`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: postAiV2CreateConversationBody,
      signal,
    },
    options,
  );
};

export const getPostAiV2CreateConversationMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAiV2CreateConversation>>,
    TError,
    { data: PostAiV2CreateConversationBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAiV2CreateConversation>>,
  TError,
  { data: PostAiV2CreateConversationBody },
  TContext
> => {
  const mutationKey = ["postAiV2CreateConversation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAiV2CreateConversation>>,
    { data: PostAiV2CreateConversationBody }
  > = (props) => {
    const { data } = props ?? {};

    return postAiV2CreateConversation(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAiV2CreateConversationMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAiV2CreateConversation>>
>;
export type PostAiV2CreateConversationMutationBody =
  PostAiV2CreateConversationBody;
export type PostAiV2CreateConversationMutationError = unknown;

/**
 * @summary Create a new conversation
 */
export const usePostAiV2CreateConversation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAiV2CreateConversation>>,
      TError,
      { data: PostAiV2CreateConversationBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAiV2CreateConversation>>,
  TError,
  { data: PostAiV2CreateConversationBody },
  TContext
> => {
  const mutationOptions = getPostAiV2CreateConversationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Conversation Details
 */
export const getAiConversationsConversationIdGetConversationDetails = (
  conversationId: string,
  params: GetAiConversationsConversationIdGetConversationDetailsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GetConversationResponse>(
    {
      url: `/ai/conversations/${conversationId}/getConversationDetails`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getGetAiConversationsConversationIdGetConversationDetailsQueryKey =
  (
    conversationId?: string,
    params?: GetAiConversationsConversationIdGetConversationDetailsParams,
  ) => {
    return [
      `/ai/conversations/${conversationId}/getConversationDetails`,
      ...(params ? [params] : []),
    ] as const;
  };

export const getGetAiConversationsConversationIdGetConversationDetailsQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getAiConversationsConversationIdGetConversationDetails>
    >,
    TError = unknown,
  >(
    conversationId: string,
    params: GetAiConversationsConversationIdGetConversationDetailsParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getAiConversationsConversationIdGetConversationDetails
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof customInstance>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetAiConversationsConversationIdGetConversationDetailsQueryKey(
        conversationId,
        params,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getAiConversationsConversationIdGetConversationDetails
        >
      >
    > = ({ signal }) =>
      getAiConversationsConversationIdGetConversationDetails(
        conversationId,
        params,
        requestOptions,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!conversationId,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getAiConversationsConversationIdGetConversationDetails
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetAiConversationsConversationIdGetConversationDetailsQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getAiConversationsConversationIdGetConversationDetails>
    >
  >;
export type GetAiConversationsConversationIdGetConversationDetailsQueryError =
  unknown;

export function useGetAiConversationsConversationIdGetConversationDetails<
  TData = Awaited<
    ReturnType<typeof getAiConversationsConversationIdGetConversationDetails>
  >,
  TError = unknown,
>(
  conversationId: string,
  params: GetAiConversationsConversationIdGetConversationDetailsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAiConversationsConversationIdGetConversationDetails
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getAiConversationsConversationIdGetConversationDetails
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getAiConversationsConversationIdGetConversationDetails
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAiConversationsConversationIdGetConversationDetails<
  TData = Awaited<
    ReturnType<typeof getAiConversationsConversationIdGetConversationDetails>
  >,
  TError = unknown,
>(
  conversationId: string,
  params: GetAiConversationsConversationIdGetConversationDetailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAiConversationsConversationIdGetConversationDetails
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getAiConversationsConversationIdGetConversationDetails
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getAiConversationsConversationIdGetConversationDetails
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAiConversationsConversationIdGetConversationDetails<
  TData = Awaited<
    ReturnType<typeof getAiConversationsConversationIdGetConversationDetails>
  >,
  TError = unknown,
>(
  conversationId: string,
  params: GetAiConversationsConversationIdGetConversationDetailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAiConversationsConversationIdGetConversationDetails
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Conversation Details
 */

export function useGetAiConversationsConversationIdGetConversationDetails<
  TData = Awaited<
    ReturnType<typeof getAiConversationsConversationIdGetConversationDetails>
  >,
  TError = unknown,
>(
  conversationId: string,
  params: GetAiConversationsConversationIdGetConversationDetailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAiConversationsConversationIdGetConversationDetails
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetAiConversationsConversationIdGetConversationDetailsQueryOptions(
      conversationId,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Subjects-Grade Mapping
 */
export const getDc1MetaSubjectsGradeMapping = (
  params: GetDc1MetaSubjectsGradeMappingParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GetMappedSubjectsResponse>(
    { url: `/dc/1/meta/subjectsGradeMapping`, method: "GET", params, signal },
    options,
  );
};

export const getGetDc1MetaSubjectsGradeMappingQueryKey = (
  params?: GetDc1MetaSubjectsGradeMappingParams,
) => {
  return [
    `/dc/1/meta/subjectsGradeMapping`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetDc1MetaSubjectsGradeMappingQueryOptions = <
  TData = Awaited<ReturnType<typeof getDc1MetaSubjectsGradeMapping>>,
  TError = unknown,
>(
  params: GetDc1MetaSubjectsGradeMappingParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1MetaSubjectsGradeMapping>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDc1MetaSubjectsGradeMappingQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDc1MetaSubjectsGradeMapping>>
  > = ({ signal }) =>
    getDc1MetaSubjectsGradeMapping(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDc1MetaSubjectsGradeMapping>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDc1MetaSubjectsGradeMappingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDc1MetaSubjectsGradeMapping>>
>;
export type GetDc1MetaSubjectsGradeMappingQueryError = unknown;

export function useGetDc1MetaSubjectsGradeMapping<
  TData = Awaited<ReturnType<typeof getDc1MetaSubjectsGradeMapping>>,
  TError = unknown,
>(
  params: GetDc1MetaSubjectsGradeMappingParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1MetaSubjectsGradeMapping>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDc1MetaSubjectsGradeMapping>>,
          TError,
          Awaited<ReturnType<typeof getDc1MetaSubjectsGradeMapping>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDc1MetaSubjectsGradeMapping<
  TData = Awaited<ReturnType<typeof getDc1MetaSubjectsGradeMapping>>,
  TError = unknown,
>(
  params: GetDc1MetaSubjectsGradeMappingParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1MetaSubjectsGradeMapping>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDc1MetaSubjectsGradeMapping>>,
          TError,
          Awaited<ReturnType<typeof getDc1MetaSubjectsGradeMapping>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDc1MetaSubjectsGradeMapping<
  TData = Awaited<ReturnType<typeof getDc1MetaSubjectsGradeMapping>>,
  TError = unknown,
>(
  params: GetDc1MetaSubjectsGradeMappingParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1MetaSubjectsGradeMapping>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Subjects-Grade Mapping
 */

export function useGetDc1MetaSubjectsGradeMapping<
  TData = Awaited<ReturnType<typeof getDc1MetaSubjectsGradeMapping>>,
  TError = unknown,
>(
  params: GetDc1MetaSubjectsGradeMappingParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDc1MetaSubjectsGradeMapping>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDc1MetaSubjectsGradeMappingQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get AI Message (Sync)
 */
export const postAiConversationsConversationIdContinueSync = (
  conversationId: string,
  getMessageRequestModel: GetMessageRequestModel,
  params: PostAiConversationsConversationIdContinueSyncParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GetMessageResponse>(
    {
      url: `/ai/conversations/${conversationId}/continue-sync`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: getMessageRequestModel,
      params,
      signal,
    },
    options,
  );
};

export const getPostAiConversationsConversationIdContinueSyncMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAiConversationsConversationIdContinueSync>>,
    TError,
    {
      conversationId: string;
      data: GetMessageRequestModel;
      params: PostAiConversationsConversationIdContinueSyncParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAiConversationsConversationIdContinueSync>>,
  TError,
  {
    conversationId: string;
    data: GetMessageRequestModel;
    params: PostAiConversationsConversationIdContinueSyncParams;
  },
  TContext
> => {
  const mutationKey = ["postAiConversationsConversationIdContinueSync"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAiConversationsConversationIdContinueSync>>,
    {
      conversationId: string;
      data: GetMessageRequestModel;
      params: PostAiConversationsConversationIdContinueSyncParams;
    }
  > = (props) => {
    const { conversationId, data, params } = props ?? {};

    return postAiConversationsConversationIdContinueSync(
      conversationId,
      data,
      params,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAiConversationsConversationIdContinueSyncMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postAiConversationsConversationIdContinueSync>>
  >;
export type PostAiConversationsConversationIdContinueSyncMutationBody =
  GetMessageRequestModel;
export type PostAiConversationsConversationIdContinueSyncMutationError =
  unknown;

/**
 * @summary Get AI Message (Sync)
 */
export const usePostAiConversationsConversationIdContinueSync = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAiConversationsConversationIdContinueSync>>,
      TError,
      {
        conversationId: string;
        data: GetMessageRequestModel;
        params: PostAiConversationsConversationIdContinueSyncParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAiConversationsConversationIdContinueSync>>,
  TError,
  {
    conversationId: string;
    data: GetMessageRequestModel;
    params: PostAiConversationsConversationIdContinueSyncParams;
  },
  TContext
> => {
  const mutationOptions =
    getPostAiConversationsConversationIdContinueSyncMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * This endpoint is intended for a streaming response.
 * @summary Get AI Message (Streaming)
 */
export const postAiConversationsConversationIdContinue = (
  conversationId: string,
  getMessageRequestModel: GetMessageRequestModel,
  params: PostAiConversationsConversationIdContinueParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GetMessageResponse>(
    {
      url: `/ai/conversations/${conversationId}/continue`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: getMessageRequestModel,
      params,
      signal,
    },
    options,
  );
};

export const getPostAiConversationsConversationIdContinueMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAiConversationsConversationIdContinue>>,
    TError,
    {
      conversationId: string;
      data: GetMessageRequestModel;
      params: PostAiConversationsConversationIdContinueParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAiConversationsConversationIdContinue>>,
  TError,
  {
    conversationId: string;
    data: GetMessageRequestModel;
    params: PostAiConversationsConversationIdContinueParams;
  },
  TContext
> => {
  const mutationKey = ["postAiConversationsConversationIdContinue"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAiConversationsConversationIdContinue>>,
    {
      conversationId: string;
      data: GetMessageRequestModel;
      params: PostAiConversationsConversationIdContinueParams;
    }
  > = (props) => {
    const { conversationId, data, params } = props ?? {};

    return postAiConversationsConversationIdContinue(
      conversationId,
      data,
      params,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAiConversationsConversationIdContinueMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postAiConversationsConversationIdContinue>>
  >;
export type PostAiConversationsConversationIdContinueMutationBody =
  GetMessageRequestModel;
export type PostAiConversationsConversationIdContinueMutationError = unknown;

/**
 * @summary Get AI Message (Streaming)
 */
export const usePostAiConversationsConversationIdContinue = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAiConversationsConversationIdContinue>>,
      TError,
      {
        conversationId: string;
        data: GetMessageRequestModel;
        params: PostAiConversationsConversationIdContinueParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAiConversationsConversationIdContinue>>,
  TError,
  {
    conversationId: string;
    data: GetMessageRequestModel;
    params: PostAiConversationsConversationIdContinueParams;
  },
  TContext
> => {
  const mutationOptions =
    getPostAiConversationsConversationIdContinueMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Follow-up Questions
 */
export const postAiGetFollowUpQuestions = (
  postAiGetFollowUpQuestionsBody: PostAiGetFollowUpQuestionsBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GetFollowUpResponse>(
    {
      url: `/ai/getFollowUpQuestions`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: postAiGetFollowUpQuestionsBody,
      signal,
    },
    options,
  );
};

export const getPostAiGetFollowUpQuestionsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAiGetFollowUpQuestions>>,
    TError,
    { data: PostAiGetFollowUpQuestionsBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAiGetFollowUpQuestions>>,
  TError,
  { data: PostAiGetFollowUpQuestionsBody },
  TContext
> => {
  const mutationKey = ["postAiGetFollowUpQuestions"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAiGetFollowUpQuestions>>,
    { data: PostAiGetFollowUpQuestionsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postAiGetFollowUpQuestions(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAiGetFollowUpQuestionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAiGetFollowUpQuestions>>
>;
export type PostAiGetFollowUpQuestionsMutationBody =
  PostAiGetFollowUpQuestionsBody;
export type PostAiGetFollowUpQuestionsMutationError = unknown;

/**
 * @summary Get Follow-up Questions
 */
export const usePostAiGetFollowUpQuestions = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAiGetFollowUpQuestions>>,
      TError,
      { data: PostAiGetFollowUpQuestionsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAiGetFollowUpQuestions>>,
  TError,
  { data: PostAiGetFollowUpQuestionsBody },
  TContext
> => {
  const mutationOptions = getPostAiGetFollowUpQuestionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Check for Profanity
 */
export const postAiPrompt = (
  profanityRequest: ProfanityRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ProfanityResponse>(
    {
      url: `/ai/prompt`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: profanityRequest,
      signal,
    },
    options,
  );
};

export const getPostAiPromptMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAiPrompt>>,
    TError,
    { data: ProfanityRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAiPrompt>>,
  TError,
  { data: ProfanityRequest },
  TContext
> => {
  const mutationKey = ["postAiPrompt"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAiPrompt>>,
    { data: ProfanityRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postAiPrompt(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAiPromptMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAiPrompt>>
>;
export type PostAiPromptMutationBody = ProfanityRequest;
export type PostAiPromptMutationError = unknown;

/**
 * @summary Check for Profanity
 */
export const usePostAiPrompt = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAiPrompt>>,
      TError,
      { data: ProfanityRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAiPrompt>>,
  TError,
  { data: ProfanityRequest },
  TContext
> => {
  const mutationOptions = getPostAiPromptMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Set View Type
 */
export const postAiSetViewType = (
  setViewtypeRequest: SetViewtypeRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<SetViewTypeResponse>(
    {
      url: `/ai/setViewType`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: setViewtypeRequest,
      signal,
    },
    options,
  );
};

export const getPostAiSetViewTypeMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAiSetViewType>>,
    TError,
    { data: SetViewtypeRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAiSetViewType>>,
  TError,
  { data: SetViewtypeRequest },
  TContext
> => {
  const mutationKey = ["postAiSetViewType"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAiSetViewType>>,
    { data: SetViewtypeRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postAiSetViewType(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAiSetViewTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAiSetViewType>>
>;
export type PostAiSetViewTypeMutationBody = SetViewtypeRequest;
export type PostAiSetViewTypeMutationError = unknown;

/**
 * @summary Set View Type
 */
export const usePostAiSetViewType = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAiSetViewType>>,
      TError,
      { data: SetViewtypeRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAiSetViewType>>,
  TError,
  { data: SetViewtypeRequest },
  TContext
> => {
  const mutationOptions = getPostAiSetViewTypeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Save View Type Count
 */
export const postDc1SaveViewTypeCount = (
  saveViewTypeCountRequest: SaveViewTypeCountRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<SetViewTypeResponse>(
    {
      url: `/dc/1/saveViewTypeCount`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: saveViewTypeCountRequest,
      signal,
    },
    options,
  );
};

export const getPostDc1SaveViewTypeCountMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postDc1SaveViewTypeCount>>,
    TError,
    { data: SaveViewTypeCountRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postDc1SaveViewTypeCount>>,
  TError,
  { data: SaveViewTypeCountRequest },
  TContext
> => {
  const mutationKey = ["postDc1SaveViewTypeCount"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postDc1SaveViewTypeCount>>,
    { data: SaveViewTypeCountRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postDc1SaveViewTypeCount(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostDc1SaveViewTypeCountMutationResult = NonNullable<
  Awaited<ReturnType<typeof postDc1SaveViewTypeCount>>
>;
export type PostDc1SaveViewTypeCountMutationBody = SaveViewTypeCountRequest;
export type PostDc1SaveViewTypeCountMutationError = unknown;

/**
 * @summary Save View Type Count
 */
export const usePostDc1SaveViewTypeCount = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postDc1SaveViewTypeCount>>,
      TError,
      { data: SaveViewTypeCountRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postDc1SaveViewTypeCount>>,
  TError,
  { data: SaveViewTypeCountRequest },
  TContext
> => {
  const mutationOptions = getPostDc1SaveViewTypeCountMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Submit AI Feedback
 */
export const postAiConversationsConversationIdUpdateScore = (
  conversationId: string,
  aiFeedbackRequest: AiFeedbackRequest,
  params?: PostAiConversationsConversationIdUpdateScoreParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<AiFeedbackresponse>(
    {
      url: `/ai/conversations/${conversationId}/update-score`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: aiFeedbackRequest,
      params,
      signal,
    },
    options,
  );
};

export const getPostAiConversationsConversationIdUpdateScoreMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAiConversationsConversationIdUpdateScore>>,
    TError,
    {
      conversationId: string;
      data: AiFeedbackRequest;
      params?: PostAiConversationsConversationIdUpdateScoreParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAiConversationsConversationIdUpdateScore>>,
  TError,
  {
    conversationId: string;
    data: AiFeedbackRequest;
    params?: PostAiConversationsConversationIdUpdateScoreParams;
  },
  TContext
> => {
  const mutationKey = ["postAiConversationsConversationIdUpdateScore"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAiConversationsConversationIdUpdateScore>>,
    {
      conversationId: string;
      data: AiFeedbackRequest;
      params?: PostAiConversationsConversationIdUpdateScoreParams;
    }
  > = (props) => {
    const { conversationId, data, params } = props ?? {};

    return postAiConversationsConversationIdUpdateScore(
      conversationId,
      data,
      params,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAiConversationsConversationIdUpdateScoreMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postAiConversationsConversationIdUpdateScore>>
  >;
export type PostAiConversationsConversationIdUpdateScoreMutationBody =
  AiFeedbackRequest;
export type PostAiConversationsConversationIdUpdateScoreMutationError = unknown;

/**
 * @summary Submit AI Feedback
 */
export const usePostAiConversationsConversationIdUpdateScore = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAiConversationsConversationIdUpdateScore>>,
      TError,
      {
        conversationId: string;
        data: AiFeedbackRequest;
        params?: PostAiConversationsConversationIdUpdateScoreParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAiConversationsConversationIdUpdateScore>>,
  TError,
  {
    conversationId: string;
    data: AiFeedbackRequest;
    params?: PostAiConversationsConversationIdUpdateScoreParams;
  },
  TContext
> => {
  const mutationOptions =
    getPostAiConversationsConversationIdUpdateScoreMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get User's Doubts List (Filtered)
 */
export const postDc1UserGetDoubtsv2 = (
  filterDoubt: FilterDoubt,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<MyQuestionResponse>(
    {
      url: `/dc/1/user/getDoubtsv2`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: filterDoubt,
      signal,
    },
    options,
  );
};

export const getPostDc1UserGetDoubtsv2MutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postDc1UserGetDoubtsv2>>,
    TError,
    { data: FilterDoubt },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postDc1UserGetDoubtsv2>>,
  TError,
  { data: FilterDoubt },
  TContext
> => {
  const mutationKey = ["postDc1UserGetDoubtsv2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postDc1UserGetDoubtsv2>>,
    { data: FilterDoubt }
  > = (props) => {
    const { data } = props ?? {};

    return postDc1UserGetDoubtsv2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostDc1UserGetDoubtsv2MutationResult = NonNullable<
  Awaited<ReturnType<typeof postDc1UserGetDoubtsv2>>
>;
export type PostDc1UserGetDoubtsv2MutationBody = FilterDoubt;
export type PostDc1UserGetDoubtsv2MutationError = unknown;

/**
 * @summary Get User's Doubts List (Filtered)
 */
export const usePostDc1UserGetDoubtsv2 = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postDc1UserGetDoubtsv2>>,
      TError,
      { data: FilterDoubt },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postDc1UserGetDoubtsv2>>,
  TError,
  { data: FilterDoubt },
  TContext
> => {
  const mutationOptions = getPostDc1UserGetDoubtsv2MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Upload Image for OCR
 */
export const postDc1QuestionsImageOCR = (
  postDc1QuestionsImageOCRBody: PostDc1QuestionsImageOCRBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  if (postDc1QuestionsImageOCRBody.file !== undefined) {
    formData.append(`file`, postDc1QuestionsImageOCRBody.file);
  }

  return customInstance<PostImage>(
    {
      url: `/dc/1/questions/imageOCR`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
      signal,
    },
    options,
  );
};

export const getPostDc1QuestionsImageOCRMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postDc1QuestionsImageOCR>>,
    TError,
    { data: PostDc1QuestionsImageOCRBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postDc1QuestionsImageOCR>>,
  TError,
  { data: PostDc1QuestionsImageOCRBody },
  TContext
> => {
  const mutationKey = ["postDc1QuestionsImageOCR"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postDc1QuestionsImageOCR>>,
    { data: PostDc1QuestionsImageOCRBody }
  > = (props) => {
    const { data } = props ?? {};

    return postDc1QuestionsImageOCR(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostDc1QuestionsImageOCRMutationResult = NonNullable<
  Awaited<ReturnType<typeof postDc1QuestionsImageOCR>>
>;
export type PostDc1QuestionsImageOCRMutationBody = PostDc1QuestionsImageOCRBody;
export type PostDc1QuestionsImageOCRMutationError = unknown;

/**
 * @summary Upload Image for OCR
 */
export const usePostDc1QuestionsImageOCR = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postDc1QuestionsImageOCR>>,
      TError,
      { data: PostDc1QuestionsImageOCRBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postDc1QuestionsImageOCR>>,
  TError,
  { data: PostDc1QuestionsImageOCRBody },
  TContext
> => {
  const mutationOptions = getPostDc1QuestionsImageOCRMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Doubt Buddy Answer
 */
export const getAiDoubtbuddyMessageIDGetAnswer = (
  messageID: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GetDoubtBuddyResponse>(
    { url: `/ai/doubtbuddy/${messageID}/getAnswer`, method: "GET", signal },
    options,
  );
};

export const getGetAiDoubtbuddyMessageIDGetAnswerQueryKey = (
  messageID?: string,
) => {
  return [`/ai/doubtbuddy/${messageID}/getAnswer`] as const;
};

export const getGetAiDoubtbuddyMessageIDGetAnswerQueryOptions = <
  TData = Awaited<ReturnType<typeof getAiDoubtbuddyMessageIDGetAnswer>>,
  TError = unknown,
>(
  messageID: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiDoubtbuddyMessageIDGetAnswer>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAiDoubtbuddyMessageIDGetAnswerQueryKey(messageID);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAiDoubtbuddyMessageIDGetAnswer>>
  > = ({ signal }) =>
    getAiDoubtbuddyMessageIDGetAnswer(messageID, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!messageID,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAiDoubtbuddyMessageIDGetAnswer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAiDoubtbuddyMessageIDGetAnswerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAiDoubtbuddyMessageIDGetAnswer>>
>;
export type GetAiDoubtbuddyMessageIDGetAnswerQueryError = unknown;

export function useGetAiDoubtbuddyMessageIDGetAnswer<
  TData = Awaited<ReturnType<typeof getAiDoubtbuddyMessageIDGetAnswer>>,
  TError = unknown,
>(
  messageID: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiDoubtbuddyMessageIDGetAnswer>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiDoubtbuddyMessageIDGetAnswer>>,
          TError,
          Awaited<ReturnType<typeof getAiDoubtbuddyMessageIDGetAnswer>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAiDoubtbuddyMessageIDGetAnswer<
  TData = Awaited<ReturnType<typeof getAiDoubtbuddyMessageIDGetAnswer>>,
  TError = unknown,
>(
  messageID: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiDoubtbuddyMessageIDGetAnswer>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiDoubtbuddyMessageIDGetAnswer>>,
          TError,
          Awaited<ReturnType<typeof getAiDoubtbuddyMessageIDGetAnswer>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAiDoubtbuddyMessageIDGetAnswer<
  TData = Awaited<ReturnType<typeof getAiDoubtbuddyMessageIDGetAnswer>>,
  TError = unknown,
>(
  messageID: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiDoubtbuddyMessageIDGetAnswer>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Doubt Buddy Answer
 */

export function useGetAiDoubtbuddyMessageIDGetAnswer<
  TData = Awaited<ReturnType<typeof getAiDoubtbuddyMessageIDGetAnswer>>,
  TError = unknown,
>(
  messageID: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiDoubtbuddyMessageIDGetAnswer>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAiDoubtbuddyMessageIDGetAnswerQueryOptions(
    messageID,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Set Doubt Buddy Answer
 */
export const postAiDoubtbuddySetAnswerByDoubtBuddy = (
  setDoubtBuddyRequest: SetDoubtBuddyRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<SetDoubtBodyResponse>(
    {
      url: `/ai/doubtbuddy/setAnswerByDoubtBuddy`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: setDoubtBuddyRequest,
      signal,
    },
    options,
  );
};

export const getPostAiDoubtbuddySetAnswerByDoubtBuddyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAiDoubtbuddySetAnswerByDoubtBuddy>>,
    TError,
    { data: SetDoubtBuddyRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAiDoubtbuddySetAnswerByDoubtBuddy>>,
  TError,
  { data: SetDoubtBuddyRequest },
  TContext
> => {
  const mutationKey = ["postAiDoubtbuddySetAnswerByDoubtBuddy"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAiDoubtbuddySetAnswerByDoubtBuddy>>,
    { data: SetDoubtBuddyRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postAiDoubtbuddySetAnswerByDoubtBuddy(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAiDoubtbuddySetAnswerByDoubtBuddyMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAiDoubtbuddySetAnswerByDoubtBuddy>>
>;
export type PostAiDoubtbuddySetAnswerByDoubtBuddyMutationBody =
  SetDoubtBuddyRequest;
export type PostAiDoubtbuddySetAnswerByDoubtBuddyMutationError = unknown;

/**
 * @summary Set Doubt Buddy Answer
 */
export const usePostAiDoubtbuddySetAnswerByDoubtBuddy = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAiDoubtbuddySetAnswerByDoubtBuddy>>,
      TError,
      { data: SetDoubtBuddyRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAiDoubtbuddySetAnswerByDoubtBuddy>>,
  TError,
  { data: SetDoubtBuddyRequest },
  TContext
> => {
  const mutationOptions =
    getPostAiDoubtbuddySetAnswerByDoubtBuddyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Set RAG Answer
 */
export const postAiRagSaveAnswerByRag = (
  setRagRequestBody: SetRagRequestBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<SetRagResponseBody>(
    {
      url: `/ai/rag/saveAnswerByRag`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: setRagRequestBody,
      signal,
    },
    options,
  );
};

export const getPostAiRagSaveAnswerByRagMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAiRagSaveAnswerByRag>>,
    TError,
    { data: SetRagRequestBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAiRagSaveAnswerByRag>>,
  TError,
  { data: SetRagRequestBody },
  TContext
> => {
  const mutationKey = ["postAiRagSaveAnswerByRag"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAiRagSaveAnswerByRag>>,
    { data: SetRagRequestBody }
  > = (props) => {
    const { data } = props ?? {};

    return postAiRagSaveAnswerByRag(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAiRagSaveAnswerByRagMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAiRagSaveAnswerByRag>>
>;
export type PostAiRagSaveAnswerByRagMutationBody = SetRagRequestBody;
export type PostAiRagSaveAnswerByRagMutationError = unknown;

/**
 * @summary Set RAG Answer
 */
export const usePostAiRagSaveAnswerByRag = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAiRagSaveAnswerByRag>>,
      TError,
      { data: SetRagRequestBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAiRagSaveAnswerByRag>>,
  TError,
  { data: SetRagRequestBody },
  TContext
> => {
  const mutationOptions = getPostAiRagSaveAnswerByRagMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Doubt Solver Solution (v3)
 */
export const postV3RagGenerateSolution = (
  doubtSolverRequest: DoubtSolverRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DoubtSolverResponse>(
    {
      url: `/v3/rag/generate_solution`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: doubtSolverRequest,
      signal,
    },
    options,
  );
};

export const getPostV3RagGenerateSolutionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV3RagGenerateSolution>>,
    TError,
    { data: DoubtSolverRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV3RagGenerateSolution>>,
  TError,
  { data: DoubtSolverRequest },
  TContext
> => {
  const mutationKey = ["postV3RagGenerateSolution"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV3RagGenerateSolution>>,
    { data: DoubtSolverRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postV3RagGenerateSolution(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV3RagGenerateSolutionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV3RagGenerateSolution>>
>;
export type PostV3RagGenerateSolutionMutationBody = DoubtSolverRequest;
export type PostV3RagGenerateSolutionMutationError = unknown;

/**
 * @summary Get Doubt Solver Solution (v3)
 */
export const usePostV3RagGenerateSolution = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV3RagGenerateSolution>>,
      TError,
      { data: DoubtSolverRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV3RagGenerateSolution>>,
  TError,
  { data: DoubtSolverRequest },
  TContext
> => {
  const mutationOptions = getPostV3RagGenerateSolutionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Set Answer by Doubt Solver
 */
export const postAiDoubsolverSetAnswerByDoubtsolver = (
  setAnswerByDoubtsolver: SetAnswerByDoubtsolver,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<SetDoubtBodyResponse>(
    {
      url: `/ai/doubsolver/setAnswerByDoubtsolver`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: setAnswerByDoubtsolver,
      signal,
    },
    options,
  );
};

export const getPostAiDoubsolverSetAnswerByDoubtsolverMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAiDoubsolverSetAnswerByDoubtsolver>>,
    TError,
    { data: SetAnswerByDoubtsolver },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAiDoubsolverSetAnswerByDoubtsolver>>,
  TError,
  { data: SetAnswerByDoubtsolver },
  TContext
> => {
  const mutationKey = ["postAiDoubsolverSetAnswerByDoubtsolver"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAiDoubsolverSetAnswerByDoubtsolver>>,
    { data: SetAnswerByDoubtsolver }
  > = (props) => {
    const { data } = props ?? {};

    return postAiDoubsolverSetAnswerByDoubtsolver(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAiDoubsolverSetAnswerByDoubtsolverMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAiDoubsolverSetAnswerByDoubtsolver>>
>;
export type PostAiDoubsolverSetAnswerByDoubtsolverMutationBody =
  SetAnswerByDoubtsolver;
export type PostAiDoubsolverSetAnswerByDoubtsolverMutationError = unknown;

/**
 * @summary Set Answer by Doubt Solver
 */
export const usePostAiDoubsolverSetAnswerByDoubtsolver = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAiDoubsolverSetAnswerByDoubtsolver>>,
      TError,
      { data: SetAnswerByDoubtsolver },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAiDoubsolverSetAnswerByDoubtsolver>>,
  TError,
  { data: SetAnswerByDoubtsolver },
  TContext
> => {
  const mutationOptions =
    getPostAiDoubsolverSetAnswerByDoubtsolverMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Doubt Solver Answer
 */
export const getAiDoubsolverMessageIDGetAnswer = (
  messageID: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GetDoubtSolverAnswer>(
    { url: `/ai/doubsolver/${messageID}/getAnswer`, method: "GET", signal },
    options,
  );
};

export const getGetAiDoubsolverMessageIDGetAnswerQueryKey = (
  messageID?: string,
) => {
  return [`/ai/doubsolver/${messageID}/getAnswer`] as const;
};

export const getGetAiDoubsolverMessageIDGetAnswerQueryOptions = <
  TData = Awaited<ReturnType<typeof getAiDoubsolverMessageIDGetAnswer>>,
  TError = unknown,
>(
  messageID: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiDoubsolverMessageIDGetAnswer>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAiDoubsolverMessageIDGetAnswerQueryKey(messageID);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAiDoubsolverMessageIDGetAnswer>>
  > = ({ signal }) =>
    getAiDoubsolverMessageIDGetAnswer(messageID, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!messageID,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAiDoubsolverMessageIDGetAnswer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAiDoubsolverMessageIDGetAnswerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAiDoubsolverMessageIDGetAnswer>>
>;
export type GetAiDoubsolverMessageIDGetAnswerQueryError = unknown;

export function useGetAiDoubsolverMessageIDGetAnswer<
  TData = Awaited<ReturnType<typeof getAiDoubsolverMessageIDGetAnswer>>,
  TError = unknown,
>(
  messageID: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiDoubsolverMessageIDGetAnswer>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiDoubsolverMessageIDGetAnswer>>,
          TError,
          Awaited<ReturnType<typeof getAiDoubsolverMessageIDGetAnswer>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAiDoubsolverMessageIDGetAnswer<
  TData = Awaited<ReturnType<typeof getAiDoubsolverMessageIDGetAnswer>>,
  TError = unknown,
>(
  messageID: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiDoubsolverMessageIDGetAnswer>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiDoubsolverMessageIDGetAnswer>>,
          TError,
          Awaited<ReturnType<typeof getAiDoubsolverMessageIDGetAnswer>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAiDoubsolverMessageIDGetAnswer<
  TData = Awaited<ReturnType<typeof getAiDoubsolverMessageIDGetAnswer>>,
  TError = unknown,
>(
  messageID: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiDoubsolverMessageIDGetAnswer>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Doubt Solver Answer
 */

export function useGetAiDoubsolverMessageIDGetAnswer<
  TData = Awaited<ReturnType<typeof getAiDoubsolverMessageIDGetAnswer>>,
  TError = unknown,
>(
  messageID: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiDoubsolverMessageIDGetAnswer>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAiDoubsolverMessageIDGetAnswerQueryOptions(
    messageID,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
